import BaseModel from './BaseModel'

export default class ScheduledPayment extends BaseModel {
  // ... ScheduledPayment-specific methods or overrides ...
}
